var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbc598",
    d: "M29.704 10.472C28.279 5.869 24.579 2.138 20 .734 15.219-.761 10.187 0 6.25 2.96 4.349 4.354 2.78 6.25 1.702 8.278A15.335 15.335 0 0 0 0 15.29c0 3.322 1.05 6.477 3.037 9.127l11.698 14.921c.265.316.729.316.976 0l11.683-14.901.015-.02c2.975-3.965 3.841-9.049 2.295-13.946"
  })));
};
export default SvgPin;